<div class="filter-background-web">
    <div class="filter-header-web">
        <div class="filter-btn-close">
            <button class="close-btn-web" style="background: none; border: none; padding: 0; cursor: pointer;" (click)="searchState.toggleProviderSearchFilter()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="close-svg-web" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 6L18 18M18 6L6 18" stroke="#888888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
    </div>
    <div class="filter-form-field-label">{{providerLabel}}</div>
    <div class="find-a-search-bar-web">
        <div class="input-icon-container-web" style="position: relative; display: flex; align-items: center;">
            <span class="search-icon-web" style="position: absolute; left: 12px; color: white; z-index: 2;">
                <svg width="20" height="19" viewBox="0 0 20 19" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.16668 2.06778C5.12911 2.06778 2.66668 4.57195 2.66668 7.661C2.66668 10.75 5.12911 13.2542 8.16668 13.2542C11.2042 13.2542 13.6667 10.75 13.6667 7.661C13.6667 4.57195 11.2042 2.06778 8.16668 2.06778ZM0.833344 7.661C0.833344 3.54226 4.11659 0.203369 8.16668 0.203369C12.2168 0.203369 15.5 3.54226 15.5 7.661C15.5 9.38437 14.9252 10.9712 13.9599 12.2341L18.8982 17.2561C19.2562 17.6201 19.2562 18.2104 18.8982 18.5744C18.5402 18.9384 17.9598 18.9384 17.6018 18.5744L12.6635 13.5524C11.4217 14.5341 9.86133 15.1186 8.16668 15.1186C4.11659 15.1186 0.833344 11.7797 0.833344 7.661Z" fill="#C5C5C5"/>
                </svg>
            </span>
            <input 
                mat-input 
                type="text" 
                [placeholder]="searchPlaceholderText" 
                class="filter-input-web" 
                [matAutocomplete]="providerNameAuto"
                [(ngModel)]="queryNameOrSpecialty"
                (ngModelChange)="filterNameOrSpecialties($event)"
                (keyup.enter)="onApplyFilters()">
            <mat-autocomplete #providerNameAuto="matAutocomplete">
                <mat-option *ngFor="let option of filteredNameOrSpecialties$ | async" [value]="option">
                    {{option}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
    <div *ngIf="specialtyCount < 1" class="filter-form-field-label">{{specialtyLabel}}</div>
    <div *ngIf="specialtyCount > 0" class="filter-form-field-label">{{specialtyLabel}} ({{specialtyCount}})</div>
    <div class="find-a-search-bar-web">
        <div class="input-icon-container-web" style="position: relative; display: flex; align-items: center;">
            <span class="search-icon-web" style="position: absolute; left: 12px; color: white; z-index: 2;">
            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.16668 2.06778C5.12911 2.06778 2.66668 4.57195 2.66668 7.661C2.66668 10.75 5.12911 13.2542 8.16668 13.2542C11.2042 13.2542 13.6667 10.75 13.6667 7.661C13.6667 4.57195 11.2042 2.06778 8.16668 2.06778ZM0.833344 7.661C0.833344 3.54226 4.11659 0.203369 8.16668 0.203369C12.2168 0.203369 15.5 3.54226 15.5 7.661C15.5 9.38437 14.9252 10.9712 13.9599 12.2341L18.8982 17.2561C19.2562 17.6201 19.2562 18.2104 18.8982 18.5744C18.5402 18.9384 17.9598 18.9384 17.6018 18.5744L12.6635 13.5524C11.4217 14.5341 9.86133 15.1186 8.16668 15.1186C4.11659 15.1186 0.833344 11.7797 0.833344 7.661Z" fill="#C5C5C5"/>
            </svg>
            </span>
            <input 
            mat-input 
            type="text" 
            [placeholder]="searchPlaceholderText"
            class="filter-input-web"
            [matAutocomplete]="specialtyAuto"
            [(ngModel)]="specialtySearchText"
            (ngModelChange)="filterSpecialties($event)">
            <mat-autocomplete #specialtyAuto="matAutocomplete" (optionSelected)="onSpecialtySelected($event)">
            <mat-option *ngFor="let specialty of (filteredSpecialties$ | async)" 
                    [value]="specialty.value">
                {{specialty.value}}
            </mat-option>
            </mat-autocomplete>
        </div>
    </div>
    <div>
        <div class="filter-chips-container" *ngIf="selectedSpecialties && selectedSpecialties.length > 0">
            <mat-chip-listbox>
                <mat-chip-option *ngFor="let specialty of selectedSpecialties" 
                                 [removable]="true"
                                 [selectable]="false" 
                                 [tabIndex]="-1"
                                 (removed)="removeSpecialty(specialty)">
                    {{specialty.value}}
                    <button matChipRemove [tabIndex]="-1">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-option>
            </mat-chip-listbox>
        </div>
    </div>
    <div class="filter-form-field-label">{{onlineSchedLabel}}</div>
    <section class="filter-checkbox-section">
        <label *ngFor="let option of (providerSearchFilters$  | async)?.onlineSchedulingList" class="container">
            <input type="checkbox" [(ngModel)]="option.isSelected">{{option.value}}
            <span class="checkmark"></span>
        </label>
    </section>
    <div class="filter-form-field-label">{{medGroupLabel}}</div>
    <section class="filter-checkbox-section">
        <label *ngFor="let option of (providerSearchFilters$  | async)?.affiliationList" class="container">
            <input type="checkbox" [(ngModel)]="option.isSelected">{{option.value}}
            <span class="checkmark"></span>
        </label>
    </section>
    <div class="filter-form-field-label">{{genderLabel}}</div>
    <section class="filter-checkbox-section checkbox-flex-row"> 
        <label *ngFor="let option of (providerSearchFilters$ | async)?.genderList" class="container">
            <input type="checkbox" [(ngModel)]="option.isSelected" (change)="onGenderChange(option)">{{option.value}}
            <span class="checkmark"></span>
        </label>
    </section>
    <div class="filter-form-field-label">{{langLabel}}</div>
    <div class="find-a-search-bar-web">
        <div class="input-icon-container-web" style="position: relative; display: flex; align-items: center;">
            <span class="search-icon-web" style="position: absolute; left: 12px; color: white; z-index: 2;">
                <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.16668 2.06778C5.12911 2.06778 2.66668 4.57195 2.66668 7.661C2.66668 10.75 5.12911 13.2542 8.16668 13.2542C11.2042 13.2542 13.6667 10.75 13.6667 7.661C13.6667 4.57195 11.2042 2.06778 8.16668 2.06778ZM0.833344 7.661C0.833344 3.54226 4.11659 0.203369 8.16668 0.203369C12.2168 0.203369 15.5 3.54226 15.5 7.661C15.5 9.38437 14.9252 10.9712 13.9599 12.2341L18.8982 17.2561C19.2562 17.6201 19.2562 18.2104 18.8982 18.5744C18.5402 18.9384 17.9598 18.9384 17.6018 18.5744L12.6635 13.5524C11.4217 14.5341 9.86133 15.1186 8.16668 15.1186C4.11659 15.1186 0.833344 11.7797 0.833344 7.661Z" fill="#C5C5C5"/>
                </svg>
            </span>
            <input 
                mat-input 
                type="text" 
                [placeholder]="searchPlaceholderText"
                class="filter-input-web"
                [matAutocomplete]="languageAuto"
                [(ngModel)]="languageSearchText"
                (ngModelChange)="filterLanguages($event)">
            <mat-autocomplete #languageAuto="matAutocomplete" (optionSelected)="onLanguageSelected($event)">
                <mat-option *ngFor="let language of filteredLanguages$ | async" [value]="language.value">
                    {{language.value}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
    <section class="filter-checkbox-section">
        <label *ngFor="let option of getDisplayedLanguages()" class="container">
            <input type="checkbox" [(ngModel)]="option.isSelected">{{option.value}}
            <span class="checkmark"></span>
        </label>
    </section>
    <div class="filter-btn-container-web">
        <button mat-button class="filter-btn-clear-web" (click)="onClearAllFilters()">{{clearBtnText}}</button>
        <button mat-button class="filter-btn-apply-web" (click)="onApplyFilters()">{{applyBtnText}}</button>
    </div>
</div>
